import { GlobalContext } from '../../../../../utils/globalprovider';
import BlueIcon from '../assets/blue.png';
import GreenIcon from '../assets/green.png';
import CyanIcon from '../assets/cyan.png';
import RedIcon from '../assets/red.png';
import MagentaIcon from '../assets/magenta.png';
import YellowIcon from '../assets/yellow.png';
import WhiteIcon from '../assets/white.png';

import './speakerform.css';
import { forwardRef, useContext, useEffect, useState, useCallback, useImperativeHandle } from 'react';

const SpeakerForm = forwardRef((props, ref) => {
  const context = useContext(GlobalContext);
  const lang = context.language;

  const [speaker, setSpeaker] = useState(null);

  useImperativeHandle(
    ref,
    () => ({
      validateForm() {
        const element = document.querySelector('#txtLastName');
        if (element) {
          if (!element.parentElement.childNodes[2]) {
            element.setAttribute('aria-invalid', 'true');
            element.setAttribute('aria-describedBy', 'error-txtLastName');

            const error = document.createElement('p');
            error.id = 'error-txtLastName';
            error.textContent =
              lang === 'fr'
                ? 'Le champ Nom est obligatoire'
                : 'Lastname is required';

            element.parentElement.classList.add('error');

            element.parentElement.appendChild(error);
          }

          element.focus();
        }
      },
    }),
    [lang]
  );

  useEffect(() => {
    setSpeaker(props.speaker);
  }, [props.speaker]);

  useEffect(() => {
    if (props.onUpdateSpeaker) {
      props.onUpdateSpeaker(speaker);
    }
  }, [props.onUpdateSpeaker, speaker]);

  const onChangeValue = useCallback(
    (event, column) => {
      const value = event.target.value;

      setSpeaker((prev) => ({ ...prev, [column]: value }));
    },
    [setSpeaker]
  );

  const onPictureChange = useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setSpeaker((prev) => ({ ...prev, picture: e.target.result }));
    };
    reader.readAsDataURL(file);
  }, []);

  const colors = [
    {
      img: BlueIcon,
      value: 'BLUE',
      fr: 'Bleu',
      en: 'Blue',
    },
    {
      img: GreenIcon,
      value: 'GREEN',
      fr: 'Vert',
      en: 'Green',
    },
    {
      img: CyanIcon,
      value: 'CYAN',
      fr: 'Cyan',
      en: 'Cyan',
    },
    {
      img: RedIcon,
      value: 'RED',
      fr: 'Rouge',
      en: 'Red',
    },
    {
      img: MagentaIcon,
      value: 'MAGENTA',
      fr: 'Magenta',
      en: 'Magenta',
    },
    {
      img: YellowIcon,
      value: 'YELLOW',
      fr: 'Jaune',
      en: 'Yellow',
    },
    {
      img: WhiteIcon,
      value: 'WHITE',
      fr: 'Blanc',
      en: 'White',
    },
  ];

  const genders = [
    {
      value: 'F',
      fr: 'Femme',
      en: 'Woman',
    },
    {
      value: 'H',
      fr: 'Homme',
      en: 'Man',
    },
    {
      value: 'N',
      fr: 'Neutre',
      en: 'Neutral',
    },
  ];

  const Picture = ({ value }) => {
    if (!value) {
      return <></>;
    }

    return <img alt="" src={value} />;
  };

  if (!speaker) {
    return <></>;
  }

  return (
    <>
      <div className="speakerContainer">
        <div className="group">
          <label htmlFor="txtFirstName">
            {lang === 'fr' ? 'Prénom' : 'Firstname'}
          </label>
          <input
            type="text"
            id="txtFirstName"
            value={speaker.firstname || ''}
            onChange={(event) => { onChangeValue(event, 'firstname')}}
            onKeyDown={(e) => {e.stopPropagation();}} // bloque la saisie clavier
            
          ></input>
        </div>
        <div className="group">
          <label htmlFor="txtLastName">
            {lang === 'fr' ? 'Nom' : 'Lastname'}
          </label>
          <input
            type="text"
            id="txtLastName"
            value={speaker.name || ''}
            onChange={(event) => onChangeValue(event, 'name')}
            onKeyDown={(e) => {e.stopPropagation();}} // bloque la saisie clavier
          ></input>
        </div>
        <div className="group">
          <label htmlFor="txtJob">
            {lang === 'fr' ? 'Fonction' : 'Job Title'}
          </label>
          <input
            type="text"
            id="txtJob"
            value={speaker.job || ''}
            onChange={(event) => onChangeValue(event, 'job')}
            onKeyDown={(e) => {e.stopPropagation();}} // bloque la saisie clavier
          ></input>
        </div>
        <div className="group">
          <fieldset>
            <legend>{lang === 'fr' ? 'Genre' : 'Gender'}</legend>
            <div className="genders">
              {genders.map((gender) => {
                return (
                  <div className="gender" key={'gender' + gender.value}>
                    <input
                      type="radio"
                      id={'gender' + gender.value}
                      name="gender"
                      value={gender.value}
                      checked={gender.value === speaker.gender}
                      onChange={(event) => onChangeValue(event, 'gender')}
                    ></input>
                    <label htmlFor={'gender' + gender.value}>
                      {lang === 'fr' ? gender.fr : gender.en}
                    </label>
                  </div>
                );
              })}
            </div>
          </fieldset>
        </div>
        <div className="group picture">
          <div className="picture-input">
            <label htmlFor="txtPicture">
              {lang === 'fr' ? 'Vignette' : 'Thumbnail'}
            </label>
            <input
              type="file"
              id="txtPicture"
              onChange={onPictureChange}
            ></input>
          </div>
          <div className="picture-value">
            <Picture value={speaker.picture}></Picture>
          </div>
        </div>
        <div className="group">
          <fieldset>
            <legend>{lang === 'fr' ? 'Couleur' : 'Color'}</legend>
            <div className="colors">
              {colors.map((color) => {
                return (
                  <div className="color" key={'color' + color.value}>
                    <input
                      type="radio"
                      id={color.value}
                      name="color"
                      value={color.value}
                      checked={color.value === speaker.color}
                      onChange={(event) => onChangeValue(event, 'color')}
                    />
                    <label htmlFor={color.value} className="sr-only">
                      {lang === 'fr' ? color.fr : color.en}
                    </label>
                    <img alt="" src={color.img} aria-hidden="true" />
                  </div>
                );
              })}
            </div>
          </fieldset>
        </div>
      </div>
    </>
  );
});

export default SpeakerForm;
